import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import disableDevToolsInProduction from "@/utils/disableDevTools";
import installTelemetry from "@/utils/telemetry";

// Neutralises React DevTools + console logging + inspector shortcuts
// in production (no-op in dev / visual-editor iframe).
disableDevToolsInProduction();

// Mirrors console.error / console.warn / uncaught errors / unhandled promise
// rejections into the backend `client_errors` collection (rate-limited).
installTelemetry();

// Badge is hidden by CSS (clip-path + visibility:hidden in index.css)
// One-time cleanup on load only — NO intervals, NO timeouts, NO observers
window.addEventListener('load', () => {
  document.querySelectorAll('#emergent-badge, [id*="emergent"], a[href*="emergent"]').forEach(el => el.remove());
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
